import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Entregas = () => import('./Entregas.vue')
const Entrega = () => import('./Entrega.vue')

export default {
    path: 'entregas',
    name: 'Gestores_Entregas',
    component: Entregas,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-GEST-ENTR-00')) {
            next()
        }
    },
    children: [{
        path: ':entregaId',
        name: 'Gestores_Entregas_Detalhar',
        component: Entrega,
        beforeEnter: (to, from, next) => {
            if (temAcesso('CRED-GEST-ENTR-00')) {
                next()
            }
        }
    }]
}
